import type { Company, GameState, Mod, Product } from "./state";

/** Timed event modifiers (see director.ts), read by sales and production. */

export function salesMod(co: Company, prod: Product): number {
  let m = 1;
  for (const x of co.mods) {
    if (x.kind === "sales" && (x.target === "all" || x.target === `product:${prod.id}` || x.target === `theme:${prod.design.theme}`)) m *= x.value;
    else if (x.kind === "audience" && x.target === prod.design.audience) m *= x.value;
  }
  return m;
}

export function modValue(co: Company, kind: Mod["kind"]): number {
  const mult = kind === "costs" || kind === "margin";
  let v = mult ? 1 : 0;
  for (const x of co.mods) if (x.kind === kind) v = mult ? v * x.value : v + x.value;
  return v;
}

/** Add a timed modifier (sales, costs, royalties...) that runs out after some weeks. */
export function addMod(state: GameState, co: Company, mod: Omit<Mod, "until"> & { weeks: number }): void {
  co.mods.push({ kind: mod.kind, value: mod.value, target: mod.target, until: state.week + mod.weeks, label: mod.label });
}
